import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = [
    "image",
    "cropX",
    "cropY",
    "cropWidth",
    "cropHeight",
    "saveButton",
    "form",
  ];

  static values = {
    initialX: Number,
    initialY: Number,
    initialWidth: Number,
    initialHeight: Number,
  };

  async connect() {
    const { default: Cropper } = await import("cropperjs");
    await import("cropperjs/dist/cropper.css");

    const opts = {
      aspectRatio: 1,
      viewMode: 1,
      autoCropArea: 1,
      responsive: true,
      checkOrientation: false,
      ready: () => {
        if (this.hasInitialWidthValue && this.initialWidthValue > 0) {
          this.cropper.setData({
            x: this.initialXValue,
            y: this.initialYValue,
            width: this.initialWidthValue,
            height: this.initialHeightValue,
          });
        }
      },
    };

    this.cropper = new Cropper(this.imageTarget, opts);
  }

  disconnect() {
    if (this.cropper) {
      this.cropper.destroy();
      this.cropper = null;
    }
  }

  dismiss() {
    const frame = this.element.closest("turbo-frame");
    if (frame) frame.innerHTML = "";
  }

  dismissOnBackdrop(event) {
    if (event.target === this.element) this.dismiss();
  }

  save(event) {
    event.preventDefault();
    if (!this.cropper) return;

    const data = this.cropper.getData(true); // round to int

    let x = Math.round(data.x);
    let y = Math.round(data.y);
    let width = Math.round(data.width);
    let height = Math.round(data.height);

    // Snap to square (rounding can drift width != height by 1 px)
    const side = Math.min(width, height);
    width = side;
    height = side;

    this.cropXTarget.value = x;
    this.cropYTarget.value = y;
    this.cropWidthTarget.value = width;
    this.cropHeightTarget.value = height;

    if (this.hasFormTarget) {
      this.formTarget.requestSubmit();
    }
  }
}
